export const addonPayValidCurrencies = ['GBP'];
